import { render } from "./Groups.vue?vue&type=template&id=57151a69&bindings={\"errors\":\"data\",\"isLoading\":\"data\",\"isCreating\":\"data\",\"results\":\"data\",\"prettyDate\":\"data\",\"showDeleteModal\":\"data\",\"filters\":\"data\",\"group\":\"data\",\"fetchData\":\"options\",\"create\":\"options\"}"
import script from "./Groups.vue?vue&type=script&lang=js"
export * from "./Groups.vue?vue&type=script&lang=js"
script.render = render

export default script